import React from "react";
import { checkTextTranslation } from "../../utils/useful";

// used for making the prop types of this component
// import PropTypes from "prop-types";

class PriceInput extends React.Component {
    state = {
        value: '',
        showValue: ''
    }

    componentDidMount() {
        if (this.props.data != null) {
            this.setState({ value: this.props.data, showValue: this.changeToPriceValue(this.props.data) })
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.data != prevProps.data) {
            // console.log(this.changeToPriceValue(this.props.data))
            if (this.props.data != null || this.state.showValue != '-')
                this.setState({ value: this.props.data, showValue: this.changeToPriceValue(this.props.data) })
        }
    }

    // Convert Persian digits to English digits
    convertPersianToEnglish(str) {
        if (!str) return str;
        const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
        const englishDigits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
        let result = str;
        persianDigits.forEach((persian, index) => {
            result = result.replace(new RegExp(persian, 'g'), englishDigits[index]);
        });
        return result;
    }

    handleChange(evt) {
        // Convert Persian digits to English before validation
        let inputValue = this.convertPersianToEnglish(evt.target.value);
        
        // Update the input value with English digits
        if (inputValue !== evt.target.value) {
            evt.target.value = inputValue;
        }
        
        // console.log(evt.target.value)
        if (evt.target.validity.valid) {
            if (!evt.target.value.includes('-') || evt.target.value.lastIndexOf('-') == 0) {
                let value = ''
                let minus = false
                if (evt.target.value != "") {
                    value = evt.target.value.replace(new RegExp(',', 'g'), '')
                    if (value != '-') {
                        // value = Number(value)
                        minus = (Number(value) < 0) ? true : false

                    } else {
                        minus = true

                    }
                } else {
                    value = ''
                    minus = false
                }

                this.setState({ minus: minus })
                // console.log(value)
                let newValue = parseFloat(value)

                if (isNaN(newValue)) {
                    newValue = null
                } else {
                    let side = value.split('.')
                    // console.log(side)
                    // console.log(String(newValue) != value)
                    if (side[1] != null && String(newValue) != value) {
                        // console.log("OK")
                        this.setState({ extraChars: '.' + side[1] })
                    } else {
                        this.setState({ extraChars: null })

                    }
                }
                // console.log(newValue)



                // if (newValue != null) {
                // this.setState({ value, showValue: this.changeToPriceValue(String(value)) });
                setTimeout(() => {
                    this.props.changeValue(this.props.header.key, newValue, this.props.extra)
                    // }
                    if (value === '-' && this.props.header.information?.negativeAllowed) {
                        newValue = '-'
                    }
                    console.log(this.changeToPriceValue(newValue) )
                    this.setState({ value, showValue: this.changeToPriceValue(newValue) });

                }, 10);

            }
        }
    }

    conditionalSettings(param, condition) {
        if (this.props.header.information.settings) {
            if (this.props.header.information.settings[param] == condition) {
                return true
            }
        }
        return false
    }



    changeToPriceValue(Svalue) {
       

        // console.log(value)
        // let Tvalue = Svalue
        if (Svalue != null) {
            let value = String(Svalue)
            if (Number(value)) {
                // console.log('TP!!!')
                let sides = String(value).split('.')
                if (sides[1] && sides[1].length > 2) {
                    value = Number(value).toFixed(2)
                }
                // console.log(Svalue.toFixed(2))

            }
            // console.log(this.state.extraChars)
            if (this.state.extraChars) {
                value = String(value) + this.state.extraChars
            }

            let final = ''
            let minus = false

            if (value != null) {
                if (parseFloat(value) < 0) {
                    // console.log(value)
                    minus = true
                    value = value.replace('-', '')
                }

                let fullValue = String(value).split('.')
                // console.log(fullValue[0])
                let newValue = fullValue[0]

                newValue = String(newValue).split('')
                let count = 0
                for (let i = newValue.length - 1; i >= 0; i--) {
                    final = newValue[i] + final
                    count++
                    if (count == 3 && i != 0) {
                        final = ',' + final
                        count = 0
                    }
                }

                final = final + (value.includes('.') ? ('.' + (fullValue[1] ? fullValue[1] : '')) : '')
            } else {
                return ''
            }
            // console.log(minus ? ('-' + final) : final)
            return minus ? ('-' + final) : final
        }else{
            return null
        }
    }


    render() {
        let info = this.props.header.information
        // Pattern now includes Persian digits (۰-۹) and English digits (0-9)
        let pattern = "^[.,0-9۰-۹]+$"
        if (info.negativeAllowed) {
            pattern = "^[-.,0-9۰-۹]+$"
        }
        return (
            <div className='mt-0 w-100' >
                <input pattern={pattern} step="0.01" onInput={this.handleChange.bind(this)} onChange={() => { }} disabled={info?.disabled} value={this.state.showValue ? this.state.showValue : ''} placeholder={checkTextTranslation(info.placeholder)} className="transpanet-input" />
            </div>
        );
    }
}

export default PriceInput;
